import React, { useEffect, useState } from 'react'
import swal from 'sweetalert2';
import Select from 'react-select';
import { getActiveCaddyMasterAll, getCaddyReportByCaddyAndDate } from '../api/caddyAPI';
import moment from 'moment';

const CaddyReport = (props) => {

    const [selectedFromDate,                    setSelectedFromDate]                    = useState(moment().toDate());
    const [selectedToDate,                      setSelectedToDate]                      = useState(moment().toDate());
    const [caddyList,                           setCaddyList]                           = useState([]);
    const [caddyReport,                         setCaddyReport]                         = useState([]);
    const [selectedCaddy,                       setSelectedCaddy]                       = useState(null);
    const [caddyDetails,                        setCaddyDetails]                        = useState(null);
    const [isInit,                              setIsInit]                              = useState(true);
    const [reportTable,                         setReportTable]                         = useState(null);

    useEffect(() => {         
        props.title("Report", "caddy-report")
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            endDate: new Date(),
            autoclose: true,
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            autoclose: true,
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        }); 
        fetchActiveCaddyMasterAll()
    }, []);
    
    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [caddyReport])

    const fetchActiveCaddyMasterAll = async() => {
        try {
            const caddyMaster =  await getActiveCaddyMasterAll();
            setCaddyList(caddyMaster)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const getReportHandler = async (e) => {
        e.preventDefault();
        var form = $('#get-report-form');
        form.validate({
            rules: {
                ddlCaddy: {
                    required: true
                }, 
            },
            messages: {
                ddlCaddy: {
                    required: "Please select caddy",
                },
            }
        });

        if (!form.valid()) return;
        try {
            const fromDate = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            const toDate = moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            const { caddyReport, caddy } = await getCaddyReportByCaddyAndDate(selectedCaddy.ID, fromDate, toDate);
            isInit ? setIsInit(false) : $('#tblCaddyReport').KTDatatable().destroy(); 
            setCaddyReport(caddyReport)
            setCaddyDetails(caddy)
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    function exportSheet(type) {

        var fromDate = moment(selectedFromDate, 'DD/MM/YYYY').format("MM/DD/YYYY");
        var toDate   = moment(selectedToDate, 'DD/MM/YYYY').format("MM/DD/YYYY");
        var Name     = $('#lblCaddyName').text();

        reportTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${Name} - ${fromDate} to ${toDate} - Caddy Report` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    function fillDataTable() {

        const dataTable = $('#tblCaddyReport').KTDatatable({
            data: {
                saveState: false,
                source: caddyReport,
                pageSize: 10
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: false,
            pagination: true,
            columns: [
                {
                    field: 'Date',
                    title: 'Date',
                    width: 80,
                    template: function (row) {
                        return `${moment(row.Date).format("MM/DD/YYYY")}`
                    },
                },
                {
                    field: 'Round',
                    title: 'Round',
                    width: 50,
                    template: function (row) {
                        return `<center> ${row.Round} </center>`
                    }
                },
                {
                    field: 'TagName',
                    title: 'Tag To',
                    template: function (row) {
                        if (row.TagID == 0) {
                            return `<span></span>`;
                        } else {
                            return `<span>
                                        <span class="btn btn-sm  ${row.TagType == 'Member' ? 'btn-success' : 'btn-warning text-white'} " title="Tag" >
                                            ${row.TagName} (${row.TagType})
                                        </span>
                                   </span>`;
                        }
                    }
                },
            ]
        });


        //export to excel
        var fromDate = moment($('#txtFromDate').val(), 'DD/MM/YYYY').format("MM/DD/YYYY");
        var toDate   = moment($('#txtToDate').val(), 'DD/MM/YYYY').format("MM/DD/YYYY");
        var Name     = $('#lblCaddyName').text();

        const ReportTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${Name} - ${fromDate} to ${toDate} - Caddy Report`,
        });
        setReportTable(ReportTable);
        $('.tableexport-caption').addClass('hidden');
    }

    return (
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{paddingTop: '0px'}}>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                <div className="kt-portlet kt-portlet--mobile">
                    <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                        <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                            <form id='get-report-form'>
                                <div className="row">
                                    <div className="form-group col-sm-1"></div>
                                    <div className="form-group col-sm-2">
                                        <Select 
                                            id="ddlCaddy" 
                                            name="ddlCaddy"
                                            className="multi-custom multi__control"
                                            placeholder="Select Caddy"
                                            value={selectedCaddy && {label: selectedCaddy.Name, value: selectedCaddy}}
                                            onChange={(e) => setSelectedCaddy(e.value)}
                                            options={caddyList.map(c => ({
                                                label: `${c.Name} (${c.CaddyNumber})`,
                                                value: c
                                            }))}
                                        />
                                    </div>
                                    <div className="form-group col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                placeholder="Select date" 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                placeholder="Select date" 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-1 vertical-center justify-content-start">
                                        <span 
                                            id="btnSearch" 
                                            className="btn btn-brand btn-sm "
                                            onClick={getReportHandler}
                                        >Search
                                        </span>
                                    </div>
                                    <div id="exportContainer" className="form-group col-xl-1 col-sm-1 vertical-center">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {caddyDetails && (
                                    <div id="selectedCaddyContainer" className="row">
                                        <div className="col-sm-12 vertical-center mb-1 border-top-light">
                                            <div className="kt-widget3" style={{width: "300px"}}>
                                                <div className="kt-widget3__item margin-t15 margin-b5">
                                                    <div className="kt-widget3__header justify-content-center padding-b0">
                                                        <div className="kt-widget3__user-img">
                                                            <img className="kt-widget3__img" id="imgCaddy" src={caddyDetails.Photo} alt="" />
                                                        </div>
                                                        <div className="kt-widget3__info">
                                                            <span className="kt-widget3__username" id="lblCaddyName">
                                                                {caddyDetails.Name} ({caddyDetails.CaddyNumber})
                                                            </span>
                                                            <br/>
                                                            <span className="kt-widget3__time">
                                                                <span id="lblFromDate"> {moment(selectedFromDate, 'DD-MM-YYYY').format('DD/MM/YYYY')} </span> To <span id="lblToDate"> {moment(selectedToDate).format('DD/MM/YYYY')} </span> 
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>
                        <div id="tblCaddyReport" className="kt-datatable table-striped "></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaddyReport